import { concat, map, isArray } from 'lodash';

export const TABLE_DATA_IMPORT = 'TABLE_DATA_IMPORT';
export const TABLE_DATA_CLEAR = 'TABLE_DATA_CLEAR';
export const TABLE_LOADING_SET = 'TABLE_LOADING_SET';
export const TABLE_SORT_TOGGLE = 'TABLE_SORT_TOGGLE';
export const TABLE_SELECT_ROW = 'TABLE_SELECT_ROW';
export const TABLE_SELECT_ROWS = 'TABLE_SELECT_ROWS';
export const TABLE_DELETE_ROWS_REQUEST = 'TABLE_DELETE_ROWS_REQUEST';
export const TABLE_DELETE_ROWS_SUCCESS = 'TABLE_DELETE_ROWS_SUCCESS';
export const TABLE_DELETE_ROWS_FAILURE = 'TABLE_DELETE_ROWS_FAILURE';

/**
 * Enable or disable loading visual
 *
 * @param {String} stateKey Table state key
 * @param {boolean} loading TRUE to display loading visuals, FALSE to disable
 * @returns {{}} Action
 */
export function setLoading(stateKey, loading) {
    return {
        type: TABLE_LOADING_SET,
        loading,
        stateKey
    };
}

/**
 * Toggle sort ordering
 *
 * @param {String} stateKey Table state key
 * @param {String} columnName Column to toggle
 * @returns {{}} Action
 */
export function toggleSort(stateKey, columnName) {
    return {
        type: TABLE_SORT_TOGGLE,
        columnName,
        stateKey
    };
}

/**
 * Data processing
 * Could be used as separate action
 *
 * @param {String} stateKey Table state key
 * @param {{}} data Table data to set
 * @param {Function|Function[]} {afterActions} Callback which will be called after success data set.
 * Callback gets response {Object} response and should return dispatchable action
 * @returns {Function} Action
 */
export function importData(stateKey, data = {}, afterActions) {
    return (dispatch) => {
        let actions = [
            {
                type: TABLE_DATA_IMPORT,
                data,
                stateKey
            }
        ];

        if (afterActions) {
            if (isArray(afterActions)) {
                actions = concat(actions, map(afterActions, func => func(data)));
            } else {
                actions.push(afterActions(data));
            }
        }

        dispatch(actions);
    };
}

/**
 * Clear table data
 *
 * @param {String} stateKey
 * @returns {Object} Action
 */
export function clearData(stateKey) {
    return {
        type: TABLE_DATA_CLEAR,
        stateKey,
    };
}

/**
 * Select single row
 *
 * @param stateKey
 * @param row
 * @returns {{type: string, stateKey: *, row: *}}
 */
export function selectRow(stateKey, row) {
    return {
        type: TABLE_SELECT_ROW,
        stateKey,
        row
    };
}

/**
 * Select all rows
 *
 * @param stateKey
 * @returns {{type: string, stateKey: *}}
 */
export function selectRows(stateKey) {
    return {
        type: TABLE_SELECT_ROWS,
        stateKey,
    };
}

/**
 * Delete selected rows
 *
 * @param stateKey
 * @param selectedRows
 * @returns {function(*)}
 */
export function deleteRows(stateKey, selectedRows) {
    const rows = selectedRows.map(row => Object.assign({},
        {
            venueId: row.venue_uid,
            saleDate: row.sale_date,
            lotNo: row.lot_no,
            lotLetter: row.lot_letter
        }
    ));

    return dispatch => {
        dispatch({
            type: TABLE_DELETE_ROWS_REQUEST,
            payload: selectedRows,
            stateKey
        });
        const url = 'ugc/shortlist';

        const init = {
            credentials: 'include',
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(rows)
        };
        return fetch(url, init)
            .then(response => (response.ok ? Promise.resolve() : Promise.reject()))
            .then(() => dispatch({
                type: TABLE_DELETE_ROWS_SUCCESS,
                payload: selectedRows,
                stateKey
            }))
            .catch(() => dispatch({
                type: TABLE_DELETE_ROWS_FAILURE,
                payload: selectedRows,
                stateKey
            }));
    };
}



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/actions/index.js